import { createFileRoute, Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { LooseEndBrandLockup } from "@/components/looseend/BrandLockup";

/**
 * WP-PT — Sharing is DEFERRED for App Alpha. The former prototype share page
 * resolved links from the creating browser's localStorage only, so a recipient
 * could never actually open one. This route now states that truthfully and
 * imports nothing from the prototype share modules.
 */
export const Route = createFileRoute("/share/$token")({
  head: () => ({
    meta: [
      { title: "Shared Loop — L∞seEnd™" },
      { name: "description", content: "Shared Loop links are not available yet." },
      { property: "og:title", content: "Shared Loop — L∞seEnd™" },
      { property: "og:description", content: "Shared Loop links are not available yet." },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: SharedLoopUnavailable,
});

function SharedLoopUnavailable() {
  return (
    <main className="min-h-dvh bg-background px-4 py-10">
      <div className="mx-auto w-full max-w-2xl">
        <header className="mb-6">
          <LooseEndBrandLockup variant="compact" wordmarkSize="lg" />
        </header>
        <section
          className="rounded-2xl border border-border bg-card p-5"
          data-testid="share-unavailable"
        >
          <h1 className="text-lg font-semibold text-foreground">
            Shared Loop links aren’t available yet
          </h1>
          <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
            L∞seEnd™ does not currently support sharing Loops with other people. This link does not
            point to anything that can be opened.
          </p>
          <div className="mt-4">
            <Button asChild>
              <Link to="/app">Open L∞seEnd™</Link>
            </Button>
          </div>
        </section>
      </div>
    </main>
  );
}
